"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-2">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-4 w-24 bg-muted/10 animate-pulse rounded-sm" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <nav className="flex flex-col gap-2">
        <Link to="/" className="text-foreground/80 hover:text-primary transition-colors">Home</Link>
        <Link to="/WealthArchitecturePage" className="text-foreground/80 hover:text-primary transition-colors">Wealth Architecture</Link>
        <Link to="/TheCarolinasEdgePage" className="text-foreground/80 hover:text-primary transition-colors">The Carolinas Edge</Link>
        <Link to="/SecureYourLegacyPage" className="text-foreground/80 hover:text-primary transition-colors">Secure Your Legacy</Link>
      </nav>;
  }
  return <nav className="flex flex-col gap-2">
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="text-foreground/80 hover:text-primary transition-colors text-sm">
          {item.label}
        </Link>)}
    </nav>;
}
export default function LegacyFooter() {
  return <section id="legacy-footer" className="dark bg-background text-foreground py-16 border-t border-primary/20">
      <div className="container mx-auto px-6 md:px-12">
        {}
        <div className="flex flex-col items-center justify-center mb-10">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1563866/img/cyradon_capital_logo_white.png" alt="Cyradon Capital Logo" className="h-16 w-auto opacity-90" />
        </div>

        {}
        <Separator className="bg-primary h-0.5 mb-12 opacity-80" />

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          
          {}
          <div>
            <h3 className="text-primary font-serif text-lg tracking-wide mb-6 uppercase border-b border-primary/20 pb-2 inline-block">
              Navigation
            </h3>
            <MenuProvider menu_id="31" className="w-full">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="text-primary font-serif text-lg tracking-wide mb-6 uppercase border-b border-primary/20 pb-2 inline-block">
              Services
            </h3>
            <ul className="space-y-3">
              {["Advanced Tax-Strategy Consulting", "Private Life Insurance Solutions", "Comprehensive Financial Planning", "Real Estate Investment Advisory", "Small Business Wealth Management"].map((service, i) => <li key={i} data-index={i} className="text-sm text-foreground/80">
                  {service}
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="text-primary font-serif text-lg tracking-wide mb-6 uppercase border-b border-primary/20 pb-2 inline-block">
              Regional Presence
            </h3>
            <div className="space-y-4 text-sm text-foreground/80">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                <p>4539 Hedgemore Drive
<div>Suite 103
</div><div>Charlotte, NC 28209</div></p>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-primary shrink-0" />
                <p>(704) 555-1234</p>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-primary shrink-0" />
                <p>contact@cyradonc.com</p>
              </div>
              <div className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                <p>Monday - Friday: 9am - 5pm</p>
              </div>
            </div>
          </div>

          {}
          <div>
            <h3 className="text-primary font-serif text-lg tracking-wide mb-6 uppercase border-b border-primary/20 pb-2 inline-block">
              Legal & Regulatory
            </h3>
            <div className="text-sm text-foreground/80 space-y-4 leading-relaxed">
              <p>
                Cyradon Capital is a registered investment adviser. Information presented is for educational purposes only and does not intend to make an offer or solicitation for the sale or purchase of any specific securities, investments, or investment strategies.
              </p>
              <p>
                Investments involve risk and, unless otherwise stated, are not guaranteed. Be sure to first consult with a qualified financial adviser and/or tax professional before implementing any strategy discussed herein.
              </p>
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 pt-8 border-t border-primary/10 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-foreground/50">
          <p>
            &copy; {new Date().getFullYear()} Cyradon Capital. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-primary transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-primary transition-colors">Terms of Use</Link>
            <Link to="#" className="hover:text-primary transition-colors">ADV Part 2A</Link>
          </div>
        </div>
      </div>
    </section>;
}